import { RiskOverviewEnds } from 'shared/Constants';
import { APIManager, axios } from 'shared/manager';

const getAll = async (
  filterType: any,
  aiFilter: any,
  fromDate?: any,
  toDate?: any
): Promise<any> =>
  APIManager.sendGet(
    RiskOverviewEnds.GET_ALL(
      filterType,
      aiFilter,
      fromDate ?? '',
      toDate ?? ''
    ),
    true,
    {},
    {},
    axios
  );

export const RiskOverviewService = {
  getAll,
};
